import {
  BreadcrumbItem,
  BreadcrumbLink,
  Center,
  Spinner,
} from "@chakra-ui/react";
import React from "react";
import { Link, useParams } from "react-router-dom";
import { BusinessBreadcrumbs } from "../../components/Breadcrumbs/Breadcrumbs";
import { PageContent } from "../../components/PageContent/PageContent";
import { PageHeading } from "../../components/PageHeading/PageHeading";
import { useBusinessContext } from "../../context/ModelContext";
import { useApiRequest } from "../../hooks/useApiRequest";

export const MembershipRequestDetail = () => {
  const business = useBusinessContext();
  const { sessionId } = useParams();
  const {
    data: membershipRequest,
    error,
    isLoading,
  } = useApiRequest(
    (apiClient) =>
      apiClient.getMembershipRequest(business.BusinessId, sessionId!),
    [sessionId]
  );
  return (
    <>
      <PageHeading>
        <BusinessBreadcrumbs>
          <BreadcrumbItem>
            <BreadcrumbLink
              as={Link}
              to={`/businesses/${business.BusinessId}/membership-requests`}
            >
              Membership Requests
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <BreadcrumbLink
              as={Link}
              to={`/businesses/${business.BusinessId}/membership-requests/${sessionId}`}
            >
              Membership Request Detail
            </BreadcrumbLink>
          </BreadcrumbItem>
        </BusinessBreadcrumbs>
        <PageHeading.Title>Membership Request Detail</PageHeading.Title>
      </PageHeading>
      <PageContent>
        {isLoading && !membershipRequest && (
          <Center>
            <Spinner />
          </Center>
        )}
      </PageContent>
    </>
  );
};
